<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <b-card>
          <div slot="header">
            <div>
              <b-row>
                <b-col sm="6">
                  <i class="fa fa-bars"></i> {{ $t('str.user-search-history') }}
                </b-col>
                <b-col sm="6">
                  <div style="display:inline-block; float:right;">
                    {{ items[0].user_name }} - {{ items[0].country_name }} - {{ items[0].email }}
                  </div>
                </b-col>
              </b-row>
            </div>
            <div>
              <b-row style="margin-top:10px;">
                <b-col sm="12">
                  <b-row>
                    <b-col sm="6">Keyword</b-col>
                    <b-col sm="3">Date Range</b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="6">
                      <b-form-input id="keyword" class="form-control" type="text" name="keyword"
                        :placeholder="$t('str.search')" v-model="keyword" @keyup.enter="getUserAllSearchHistory()">
                      </b-form-input>
                    </b-col>
                    <b-col sm="3">
                      <flat-pickr :config="dateConfig" v-model="dateRange" id="date_range" class="form-control"
                        name="date_range"></flat-pickr>
                    </b-col>
                    <b-col sm="3">
                      <b-button type="button" variant="secondary" @click="resetFilter()" style="float:right;">{{
                          $t('str.reset-filter')
                      }}</b-button>&nbsp;
                      <b-button type="submit" variant="primary" @click="getUserAllSearchHistory()">{{ $t('str.search')
                      }}
                      </b-button>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row style="margin-top:10px;">
                <b-col sm="12">
                  <b-row>
                    <b-col sm="3">Result Status</b-col>
                    <b-col sm="3">Category</b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="3">
                      <b-form-select id="found" name="found" :plain="true" v-model="found" style="height:100%;">
                        <option value="">All</option>
                        <option value="found">Found only</option>
                        <option value="notfound">Not found only</option>
                      </b-form-select>
                    </b-col>
                    <b-col sm="3">
                      <b-form-select id="category" name="category" :plain="true" v-model="category"
                        style="height:100%;">
                        <option value="">All</option>
                        <option value="4w">4W</option>
                        <option value="2w">2W</option>
                      </b-form-select>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <!-- 
              <b-row style="margin-top:10px;">
                <b-col sm="4">
                  <b-form @submit.prevent="getUserAllSearchHistory()">
                    <b-input-group>
                      <b-form-input id="keyword" type="text" name="keyword"
                        :placeholder="$t('str.search')"
                        v-model="keyword"
                        @keyup.enter="getUserAllSearchHistory()"></b-form-input>
                      <b-input-group-append>
                        <b-button type="submit" variant="primary">{{ $t('str.search') }}</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form>
                </b-col>
                <b-col sm="6"></b-col>
                <b-col sm="2">
                  <b-button type="button" variant="secondary" @click="resetFilter()">{{ $t('str.reset-filter') }}</b-button>
                </b-col>
              </b-row>
              <b-row style="margin-top:10px;"></b-row> -->
            </div>
          </div>
          <p :class="{ 'text-center': true, 'd-none': items.length }" class="">{{ $t('str.no-data') }}</p>
          <b-table :class="{ 'd-none': !items.length }" :hover="hover" :striped="striped" :bordered="bordered"
            :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage">
            <template slot="not_found" slot-scope="data">
              {{ data.item.not_found ? 'Not Found' : 'Found' }}
            </template>
            <template slot="created_at" slot-scope="data">
              {{ data.item.created_at | moment('from', 'now') }}
            </template>
          </b-table>
          <nav :class="{ 'd-none': !items.length }">
            <paging :current-page="currentPage" :total-pages="totalPage" @page-changed="pageOneChanged" prev-text="Prev"
              next-text="Next" />
          </nav>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'

import Pagination from '@/views/component/Pagination'
import Buttons from '@/views/component/Buttons'

export default {
  name: 'UserSearchHistory',
  components: {
    'paging': Pagination,
    'buttons': Buttons
  },
  props: {
    hover: { type: Boolean, default: false },
    striped: { type: Boolean, default: false },
    bordered: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
    fixed: { type: Boolean, default: false }
  },
  data() {
    return {
      items: [],
      fields: [
        { key: 'value', label: 'Keyword', sortable: true },
        { key: 'not_found', label: 'Result Status', sortable: true },
        { key: 'created_at', label: 'Last Searched', sortable: true },
        { key: 'vehicle_category', label: 'Category', sortable: true }
      ],
      keyword: '',
      found: '',
      count: 'desc',
      dateRange: (moment().subtract(1, "months").format('YYYY-MM-DD')) + ' - ' + (moment().format('YYYY-MM-DD')),
      dateConfig: {
        locale: { rangeSeparator: ' - ' },
        mode: "range",
        altInput: true,
        altFormat: "d M Y",
        dateFormat: "Y-m-d",
        defaultDate: [(moment().subtract(1, "months").format('YYYY-MM-DD')), (moment().format('YYYY-MM-DD'))]
      },
      category: '',
      currentPage: 1,
      totalPage: 0
    }
  },
  methods: {
    async getUserAllSearchHistory(page) {
      this.$auth.checkSession()
      var userId = this.$route.params.id

      let dates = this.dateRange.split(' - ')

      var trail = `?limit=${this.$helper.envi.VUE_APP_PAGING_LIMIT}`
      if (page) trail = `${trail}&page=${page}`
      if (this.keyword != '') trail = `${trail}&keyword=${this.keyword}`
      if (this.found != '') trail = `${trail}&found=${this.found}`
      if (this.dateRange != '') trail = `${trail}&start_date=${dates[0]}&end_date=${dates[1]}`
      if (this.count != '') trail = `${trail}&count=${this.count}`
      if (this.category != '') trail = `${trail}&category=${this.category}`

      try {
        var getData = await axios.get(`${this.$helper.envi.VUE_APP_API_URL}/User/${userId}/SearchHistory${trail}`, {
          headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
        })

        this.items = getData.data.data
        if (this.items[0].user_id == 0)
          this.items[0].country_name = 'Guest'

        this.currentPage = getData.data.meta.page
        this.totalPage = getData.data.meta.pageCount
      } catch (e) {
        console.log(e.response)
      }
    },
    resetFilter() {
      this.keyword = ''
      this.getUserAllSearchHistory()
    },
    pageOneChanged(pageNum) {
      this.currentPage = pageNum
      this.getUserAllSearchHistory(pageNum)
    }
  },
  created() {
    this.getUserAllSearchHistory()
  }
}
</script>